import { useTypedSelector } from "../../../app/store"
import { useContext } from "react"
import { AuthContext } from "../context/AuthContext"

/**
 * A custom hook that provides access to auth state from either Redux or Context.
 * This allows components to use either approach without changing their code.
 *
 * @returns Auth state from Redux (preferred) or Context
 */
export function useAuthState() {
  // Always call hooks at the top level - no conditionals
  const reduxAuth = useTypedSelector((state) => state.authSlice)

  // Try to get context auth, but don't throw if provider is missing
  // This allows the app to work with Redux only
  const contextAuth = useContext(AuthContext)

  // If Redux auth is available, use it
  if (reduxAuth.user) {
    return {
      user: reduxAuth.user,
      organization: reduxAuth.organization,
      role: reduxAuth.role,
      isAuthenticated: reduxAuth.isAuthenticated,
    }
  }

  // Fall back to Context API if available
  if (contextAuth && contextAuth.user) {
    return {
      user: contextAuth.user,
      organization: contextAuth.organization,
      role: contextAuth.role,
      isAuthenticated: contextAuth.isAuthenticated,
    }
  }

  // If neither Redux nor Context is available, return empty state
  return {
    user: null,
    organization: null,
    role: null,
    isAuthenticated: false,
  }
}
